import SeeAllSlide from './SeeAllSlide';
import { default as Slider } from './Slider';
import DefaultNextButton from './lego/DefaultNextButton';
import DefaultPreviousButton from './lego/DefaultPreviousButton';
export { SeeAllSlide, DefaultPreviousButton, DefaultNextButton };
export default Slider;
